import { FormControl, FormHelperText, FormLabel, Input, Select, Option } from '@mui/joy';
import { useWatch, useFormContext, Controller } from 'react-hook-form';
import { ALL_UNITS_OPTIONS } from '@/features/units/schema';
import { UnitsSelect } from './UnitsSelect';

export function FormAmountUnit({ path, label, placeholder = 'Amount', sx }) {
  const form = useFormContext();
  const amountName = path ? `${path}.amount` : 'amount';
  const unitName = path ? `${path}.unit` : 'unit';
  
  const unit = useWatch({ name: unitName });
  const showAmount = unit !== 'to taste';
  
  const amountError = form.formState.errors[amountName];
  const unitError = form.formState.errors[unitName];
  const hasError = !!amountError || !!unitError;
  const errorMessage = amountError?.message || unitError?.message;

  if (!showAmount) {
    return <UnitsSelect name={unitName} label={label}sx={sx} />                
  }

  return (
    <FormControl error={hasError} sx={sx}>
      {label && <FormLabel>{label}</FormLabel>}
      <Input
        {...form.register(amountName)}
        type="number"
        placeholder={placeholder}
        slotProps={{ input: { min: 0, step: '.01' }}}
        sx={{ paddingRight: '1px' }}
        endDecorator={
          <Controller
            name={unitName}
            control={form.control}
            render={({ field: { ref, value, onChange, onBlur } }) => (
              <Select
                ref={ref}
                value={value || ''}
                onChange={(_, newValue) => onChange(newValue)}
                onBlur={onBlur}
                variant="plain"
                sx={{
                  '--Select-radius': '0px',
                  borderLeft: '1px solid',
                  borderColor: 'divider',
                  borderRadius: '0 var(--Input-radius) var(--Input-radius) 0',
                  marginRight: '-1px',
                  minWidth: '90px',
                }}
              >
                {ALL_UNITS_OPTIONS.map((option) => (
                  <Option key={option.value} value={option.value}>
                    {option.label}
                  </Option>
                ))}
              </Select>
            )}
          />
        }
      />
      {hasError && <FormHelperText>{errorMessage}</FormHelperText>}
    </FormControl>
  );
}
